/* ------------------------------------------------------------------
medium_article_listのスライダーをset
// TODO: esbuild移行時に命名やimportできるようにリファクタリング必要
--------------------------------------------------------------------- */
function setMediumListSliders() {
  $(".jsSlider4").each(function () {
    const slider = $(this);

    if (!slider.is(":visible")) {
      return;
    }

    if (slider.hasClass("slick-initialized")) {
      slider.slick("setPosition");
      return;
    }

    slider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: true,
    });
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default setMediumListSliders;
